module.exports = __webpack_public_path__ + "img/四川天府新区世纪锦城幼儿园.4bf43960.jpg";